"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./version");
tslib_1.__exportStar(require("@uifabric/utilities"), exports);
//# sourceMappingURL=Utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Utilities.js
// module id = 592
// module chunks = 0